/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type VerificationStatus =
  (typeof VerificationStatus)[keyof typeof VerificationStatus];

export const VerificationStatus = {
  pending: "pending",
  pending_fallback: "pending_fallback",
  approved: "approved",
  declined: "declined",
  needs_review: "needs_review",
  errored: "errored",
} as const;
